<template>
  <div
    class="t-lk-lead-list-item"
    :class="{
      't-lk-lead-list-item--new': item.status === 0
    }"
  >
    <div class="t-lk-lead-list-item__heading">
      <div class="t-lk-lead-list-item__img">
        <img
          v-if="item.img"
          :src="item.img"
          :alt="item.name"
        >
      </div>

      <div class="t-lk-lead-list-item__date">{{ item.date }}</div>

      <div
        class="t-lk-lead-list-item__name"
      >{{ item.name }}</div>
    </div>

    <div class="t-lk-lead-list-item__info-wrapper">
      <div class="t-lk-lead-list-item__info">
        <template
          v-for="listItem in item.list"
        >
          <div
            class="t-lk-lead-list-item__title--main"
          >{{ listItem.name }}</div>
          <div
            class="t-lk-lead-list-item__value--main"
          >{{ listItem.value }}</div>
        </template>

        <template v-if="item.status !== 0">
          <div class="t-lk-lead-list-item__title">{{ $root.staticText.lk.leadsStatus }}</div>
          <div class="t-lk-lead-list-item__value">
            {{ item.status === 1
                ? $root.staticText.lk.leadsStatus4
                : $root.staticText.lk.leadsStatus5
            }}
          </div>
    
          <div class="t-lk-lead-list-item__title">
            {{ item.status === 1
                ? $root.staticText.lk.leadsStatus2
                : $root.staticText.lk.leadsStatus3
            }}
          </div>
          <div
            v-if="item.status === 1"
            class="t-lk-lead-list-item__value"
          >
            {{ $root.staticText.lk.leadsWorkTimer + ' ' + timer(item.timer, true, item.id) }}
          </div>
    
          <template v-else-if="item.status === 2">
            <div
              v-if="item.noConfirm"
              class="t-lk-lead-list-item__value"
              @click.stop.prevent=""
            >
              <lk-date-lead-cmp
                :ref="'date-picker-ref'"
                :item="item"
                @change:date="handleChangeDate"
              />
            </div>
    
              <div
                v-else
                class="t-lk-lead-list-item__value"
              >{{ item.dateDeal }}</div>      
          </template>
        </template>
      </div>

      <div
        v-if="item.status === 0"
        class="t-lk-lead-list-item__status"
      >
        {{ $root.staticText.lk.leadsStatusText + ' ' }}
  
        <span>{{ timer(item.timer, false, item.id) }}</span>
      </div>
    </div>

    <div class="t-lk-lead-list-item__buttons">
      <template v-if="item.status === 0">
        <!-- Принять -->
        <div
          class="t-btn _green _lk"
          @click.prevent.stop="handleAcceptLead"
        >
          {{ $root.staticText.lk.leadsWorkBtn }}
        </div>
        
        <!-- Отказаться -->
        <div
          class="t-btn _border-gray _lk"
          @click.prevent.stop="handleCloseLead"
        >
          {{ $root.staticText.lk.leadsWorkBtn2 }}
        </div>
      </template>

      <router-link
        v-if="item.link"
        class="t-lk-lead-list-item__link-to t-btn _green _lk"
        :to="item.link"
      >
       {{ $root.staticText.lk.leadDetail }}
      </router-link>


    </div>

    <!-- <div class="t-lk-lead-list-item__buttons"> -->
      <!-- Принять -->
      <!-- <div
        v-if="item.status === 0"
        class="t-btn _green _lk"
        @click.prevent.stop="handleAcceptLead"
      >
        {{ $root.staticText.lk.leadsWorkBtn }}
      </div> -->

      <!-- Увеличить сроки -->
      <!-- <lk-date-lead-cmp
        v-else-if="item.status === 1"
        :item="item"
        :is-btn="true"
        @change:date="handleChangeDate"
      /> -->
<!--                <div-->
<!--                    v-else-if="item.status === 1 && item.timer.day === 0"-->
<!--                    class="t-btn _green _lk"-->
<!--                    @click.prevent.stop=""-->
<!--                >-->
<!--                    {{ $root.staticText.lk.leadsWorkBtn3 }}-->
<!--                </div>-->

    <!-- Отказаться -->
      <!-- <div
        v-if="item.status === 0"
        class="t-btn _border-gray _lk"
        @click.prevent.stop="handleCloseLead"
      >
        {{ $root.staticText.lk.leadsWorkBtn2 }}
      </div>
      <div
        v-else-if="item.status === 1"
        class="t-lk-lead-list-item__select-option"
        :class="{
          't-lk-lead-list-item__select-option--opened': isChangeStatusOpened
        }"
        @click.prevent.stop="toggleChangeStatus"
        ref="dropdown-ref"
      >
        <div class="t-lk-lead-list-item__select-option-trigger">
          {{ $root.staticText.lk.leadsWorkBtn4 }}
        </div>

        <transition name="fade">
          <div
            v-if="isChangeStatusOpened"
            class="t-lk-lead-list-item__select-option-list"
            v-click-outside="handleClickOutside"
          > -->
            <!-- Выиграл -->
            <!-- <div
              class="t-lk-lead-list-item__select-option-item"
              @click.prevent.stop="changeStatusAndShowDate"
            >
              {{ $root.staticText.lk.leadsStatus5 }}
            </div> -->

            <!-- В работе -->
            <!-- <div
                class="t-lk-lead-list-item__select-option-item"
                @click.prevent.stop="changeStatus(item, 1)"
            >
                {{ $root.staticText.lk.leadsStatus4 }}
            </div> -->

            <!-- Сделка не состоялась -->
            <!-- <div
              class="t-lk-lead-list-item__select-option-item"
              @click.prevent.stop="handleChangeStatus(3)"
            >
              {{ $root.staticText.lk.leadsStatus6 }}
            </div> -->
          <!-- </div> -->
        <!-- </transition> -->
      <!-- </div> -->
      <!-- Добавить контакты -->
      <!-- <div
        v-if="item.status === 1 && item.optionsContacts.length"
        class="t-btn _border-gray _lk"
        @click.prevent.stop="modalType_attachContactOpen({
          optionsContacts: item.optionsContacts,
          leadId: item.id,
          attachHandler: updateLeadsPageData
        })"
      >
        {{ $root.staticText.lk.leadsWorkBtn5 }}
      </div>
    </div> -->

    <!-- <div
      v-if="item.contactCount"
      class="t-lk-lead-list-item__contacts"
    >
      {{ item.contactCount }}
      {{ $root.num2str(item.contactCount, $root.staticText.lk.leadsContactCount) }}
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';

import lkLeadDate from '@components/lk/lk-date-lead/lk-date-lead.vue';

export default {
  name: 'lk-lead-list-item',
  components: {
    'lk-date-lead-cmp': lkLeadDate,
  },
  props: {
    item: {
      type: Object,
      default: {
        id: 1,
        link: null,
        img: null,
        date: "25.07.2020",
        name: "Лид по продукту TrendMicro",
        list: () => [],
        status: 0,
        timer: () => ({
          day: 0,
          hour: 0,
          minute: 5,
        }),
        dateDeal: "20.11.2021",
        countChangeDate: 0,
        optionsContacts: () => [],
        contactCount: 0
      }
    }
  },
  data () {
    return {
      isChangeStatusOpened: false
    }
  },
  computed: {
    ...mapGetters({
      reasons: 'lk/leads/getReasons'
    })
  },
  methods: {
    ...mapActions({
      // lead actions
      acceptLead: 'lk/leads/acceptLead',
      refuseLead: 'lk/leads/refuseLead',
      closeLead: 'lk/leads/closeLead',
      getLeadsPage: 'lk/leads/getLeadsPage',
      changeLeadStatus: 'lk/leads/changeStatus',
      changeLeadDate: 'lk/leads/changeDate',
      // modals
      modalType_lkAcceptLeadModal: 'modal/modalType_lkAcceptLeadModal',
      modalType_lkErrorOpen: 'modal/modalType_lkErrorOpen',
      modalType_lkSuccessOpen: 'modal/modalType_lkSuccessOpen',
      modalType_refuseLeadOpen: 'modal/modalType_refuseLeadOpen',
      modalType_attachContactOpen: 'modal/modalType_attachContactOpen',
      modalType_changeDateOpen: 'modal/modalType_changeDateOpen'
    }),
    ...mapMutations({
      setLeadItemTimer: 'lk/leads/setItemLeadTimer',
      setLeadItem: 'lk/leads/setItemLead',
      // setPortalIsOpened: 'portal/setIsOpened'
    }),
    toggleChangeStatus () {
      this.isChangeStatusOpened = !this.isChangeStatusOpened
    },
    async updateLeadsPageData () {
      await this.getLeadsPage(this.$route.query);
    },
    async handleChangeStatus (status, date) {
      this.isChangeStatusOpened = false;

      // если сделака не состоялась
      if (status === 3) {
        this.modalType_refuseLeadOpen({
          reasons: this.reasons,
          status,
          leadId: this.item.id,
          overflowNone: true,
          refuseHandler: this.updateLeadsPageData
        });
        return;
      } 

      const { success } = await this.changeLeadStatus({
        id: this.item.id,
        status,
        date
      })

      if (!success) return;
      await this.updateLeadsPageData();
    },
    async handleCloseLead () {
      const { data, success } = await this.closeLead({
        id: this.item.id
      })

      if (!success) return;

      await this.updateLeadsPageData();
    },
    async handleAcceptLead () {
      this.modalType_lkAcceptLeadModal({
        leadId: this.item.id,
        acceptLeadHandler: this.updateLeadsPageData
      })
    },
    async handleChangeDate ({ date }) {
      if (this.item.countChangeDate >= 2) {
        this.modalType_changeDateOpen({
          leadId: this.item.id,
          date,
          changeDateHandler: this.updateLeadsPageData
        });
        return;
      } 
      
      if (this.item.noConfirm) {
        // меняем статус на двояк + дата
        // переиспользуем уже реализованный метод
        await this.handleChangeStatus(2, date);
        return;
      }

      const { success } = await this.changeLeadDate({
        id: this.item.id,
        date
      })

      if (!success) return;
      
      await this.updateLeadsPageData();
    },
    changeStatusAndShowDate () {
      this.setLeadItem({
        id: this.item.id,
        name: 'status',
        value: 2
      });

      this.$nextTick(() => {
        this.$refs[`date-picker-ref`].clickDate()
      })
    },
    openError(data) {
      let text = this.$root.staticText.modal.errorText;
      if (data.errors && data.errors.length > 0) {
          let key = Object.keys(data.errors)[0];
          if (data.errors[key][0]) {
              text = data.errors[key][0];
          }
      }

      this.modalType_lkErrorOpen({
        title: this.$root.staticText.lk.lkErrorTitle,
        text: text,
        closeBthNone: true
      });
    },
    // typeMass false - 1 день, typeMass true - 1 дня (склонение слова день)
    // честное слово, когда рефаторил не понял для чего это надо, поэтому оставил без зименений
    timer (timer, typeMass, id) {
      let keyDay = "day";
      let keyHour = "hour";
      let keyMinute = "minute";
      if (typeMass) {
          keyDay = "day2";
          keyHour = "hour2";
          keyMinute = "minute2";
      }
      let day = timer.day + ' ' + this.$root.num2str(timer.day, this.$root.staticText.lk[keyDay]);

      if (timer.day > 1) {
        return day;
      } else {
        // запускаем таймер один раз
        if (!this.timerId) {
          this.timerId = setInterval(() => {
            if (timer.minute === 0) {
              if (timer.hour === 0) {
                if (timer.day === 0) {
                  clearInterval(this.timerId);
                  // запрос на обновление данных
                  this.updateLeadsPageData();
                } else {
                  if (timer.day !== 0) {
                    this.setLeadItemTimer({id, name: 'hour', value: 23});
                    // timer.hour = 23;
                    this.setLeadItemTimer({id, name: 'minute', value: 59});
                  }
                  this.setLeadItemTimer({id, name: 'day', value: timer.day - 1});
                  // timer.day = timer.day - 1;
                }
              } else {
                if (timer.day !== 0 || timer.hour !== 0) {
                  this.setLeadItemTimer({id, name: 'minute', value: 59});
                  // timer.minute = 59;
                }
                this.setLeadItemTimer({id, name: 'hour', value: timer.hour - 1});
                // timer.hour = timer.hour - 1;
              }
            } else {
              this.setLeadItemTimer({id, name: 'minute', value: timer.minute - 1});
              // timer.minute = timer.minute - 1;

              if (timer.minute === 0 && timer.hour === 0 && timer.day === 0) {
                clearInterval(this.timerId);
                // запрос на обновление данных
                this.updateLeadsPageData;
              }
            }
          }, 60000);
        }

        day = timer.day + ' ' + this.$root.num2str(timer.day, this.$root.staticText.lk[keyDay]);
        let hour = timer.hour + ' ' + this.$root.num2str(timer.hour, this.$root.staticText.lk[keyHour]);
        let minute = timer.minute + ' ' + this.$root.num2str(timer.minute, this.$root.staticText.lk[keyMinute]);

        return (timer.day === 0) ?
          (timer.hour === 0) ? minute : hour + ' ' + minute :
          day + ' ' + hour + ' ' + minute;
      }
    },
    handleClickOutside (event) {
      this.isChangeStatusOpened = false;
    }
  },
  beforeDestroy() {
    clearInterval(this.timerId);
  },

}
</script>

<!-- <style lang="sass">
.t-lk-leads-work__item
  animation-name: fade-in
  animation-duration: 1000ms
  opacity: 1

@keyframes fade-in
  0%
    opacity: 0

  100%
    opacity: 1

</style> -->


// WEBPACK FOOTER //
// src/templates/components/lk/lk-leads-list/lk-lead-list-item.vue